import { applyMiddleware, compose, createStore } from 'redux'
import { persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createBlacklistFilter } from 'redux-persist-transform-filter'
import createEncryptor from 'redux-persist-transform-encrypt'
import immutableStateInvariant from 'redux-immutable-state-invariant'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'connected-react-router'
import rootReducer, { initApp } from './reducers'

// you want to remove some keys before you save
const saveAuthFilter = createBlacklistFilter('auth', ['isLoggingIn'])

const saveCommonsFilter = createBlacklistFilter('commons', ['appInfo'])

const saveChatFilter = createBlacklistFilter('chat', [
  'apiInitialized',
  'history',
])

const routerFilter = createBlacklistFilter('router', ['location'])

const encryptor = createEncryptor({
  secretKey: 'Malmö FF SM-guld 2018',
})

const middleware = history =>
  applyMiddleware(thunk, immutableStateInvariant(), routerMiddleware(history))

export const prodConfig = {
  key: 'primary',
  storage,
  blacklist: ['password', 'notify'],
  transforms: [
    saveAuthFilter,
    saveChatFilter,
    routerFilter,
    saveCommonsFilter,
    encryptor,
  ],
}

export default function configureStore(history, sentryReduxEnhancer) {
  const store = createStore(
    rootReducer(prodConfig, history),
    compose(middleware(history), sentryReduxEnhancer),
  )
  const persistor = persistStore(store, null, initApp(store))
  return { store, persistor }
}
